import { createSelector } from 'reselect';
import {
    prepareHalvPrice,
    prepareHelPrice,
    preparePlusPackagePrice,
    prepareTillagsAllRiskPrice,
    prepareTillagsHyrbilPrice,
    prepareTrafikPrice
} from '../../services/calculation-data/company-car/calculation-data-service';

const firstPremiumList = state =>
    state.calculationData.calculatedData.calculationOut.premiumList;
const paymentTerm = state =>
    state.calculationData.calculatedData.calculation.paymentTerm;

export const trafikPriceSelector = createSelector(
    firstPremiumList,
    paymentTerm,
    (firstPremiumList, paymentTerm) =>
        prepareTrafikPrice(firstPremiumList, paymentTerm)
);
export const halvPriceSelector = createSelector(
    firstPremiumList,
    paymentTerm,
    (firstPremiumList, paymentTerm) =>
        prepareHalvPrice(firstPremiumList, paymentTerm)
);
export const helPriceSelector = createSelector(
    firstPremiumList,
    paymentTerm,
    (firstPremiumList, paymentTerm) =>
        prepareHelPrice(firstPremiumList, paymentTerm)
);
export const plusPackagePriceSelector = createSelector(
    firstPremiumList,
    firstPremiumList => preparePlusPackagePrice(firstPremiumList)
);
export const tillagsHyrbilPriceSelector = createSelector(
    firstPremiumList,
    firstPremiumList => prepareTillagsHyrbilPrice(firstPremiumList)
);
export const tillagsAllriskPriceSelector = createSelector(
    firstPremiumList,
    firstPremiumList => prepareTillagsAllRiskPrice(firstPremiumList)
);
